import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private messageService = inject(MessageService);

  success(detail: string, summary: string = 'Éxito'): void {
    this.messageService.add({ severity: 'success', summary, detail });
  }

  error(detail: string, summary: string = 'Error'): void {
    this.messageService.add({ severity: 'error', summary, detail });
  }
}
